/* Individual Shopify flavor lines. Prices must be enforced by Shopify/app discounts. */
(() => {
  const vip = {id:49764198416611,handle:'pint-of-the-month-exclusive-mystery-flavor',name:'Exclusive Mystery Flavor',planId:9840165091,groupId:'225f953662abeec6201cd98a1131f1766453b3e8'};
  const totals = {6:8900, 9:11900, 12:14900};
  const target = (size, subscribe) => Math.round(totals[size] * (subscribe ? 0.9 : 1));
  const isBox = item => item.properties?._browndog_box === 'individual-v2';
  function restore(lines, cards) {
    const quantities = new Map();
    const planId = lines[0]?.selling_plan_allocation?.selling_plan?.id || null;
    for (const item of lines) {
      if ((item.selling_plan_allocation?.selling_plan?.id || null) !== planId) throw Error('This box has mixed subscription options. Please review your cart.');
      if (String(item.product_id) === '9675837341923') {
        if (lines.length !== 1 || item.quantity !== 1) throw Error('Please review this older cart before editing. The builder supports one box at a time.');
        for (const [name, value] of Object.entries(item.properties || {})) {
          if (!/^Flavor \d+$/.test(name)) continue;
          const match = String(value).match(/^(\d+) × (.+)$/);
          const card = match && cards.find(c => c.name === match[2]);
          if (!card || Number(match[1]) < 1) throw Error('One of your saved flavors is no longer listed. Please review your cart.');
          quantities.set(String(card.id), (quantities.get(String(card.id)) || 0) + Number(match[1]));
        }
      } else {
        const id = String(item.variant_id);
        if (!cards.some(c => String(c.id) === id)) throw Error('One of your saved flavors is no longer listed. Please review your cart.');
        quantities.set(id, (quantities.get(id) || 0) + item.quantity);
      }
    }
    if (!quantities.size) throw Error('This box has no saved flavors to edit.');
    return quantities;
  }
  function verify(cart, id, selections, expected, planId) {
    const lines = cart.items.filter(item => isBox(item) && item.properties._box_id === id);
    const actual = new Map();
    let sum = 0;
    for (const item of lines) {
      actual.set(String(item.variant_id), (actual.get(String(item.variant_id)) || 0) + item.quantity);
      sum += item.final_line_price;
      if ((item.selling_plan_allocation?.selling_plan?.id || null) !== (planId || null)) throw Error('The subscription option did not match. Your box has not been sent to checkout.');
    }
    if (actual.size !== selections.length || selections.some(s => actual.get(String(s.id)) !== s.quantity)) throw Error('The cart does not match your selected flavors.');
    if (sum !== expected) throw Error('Your box discount is not ready yet. Your selections are saved; please try again later.');
    // Order-level discounts can change the promised box total after line discounts.
    if (cart.cart_level_discount_applications?.length) throw Error('Another cart discount is applied. Review the cart before continuing.');
    return lines;
  }
  async function prepare(selections, {subscribe, frequency, boxId, getProduct, club = false}) {
    const count = selections.reduce((n, s) => n + s.quantity, 0);
    if (!totals[count] || selections.some(s => !Number.isSafeInteger(s.quantity) || s.quantity < 1) || new Set(selections.map(s => String(s.id))).size !== selections.length) throw Error('Choose exactly 6, 9, or 12 pints.');
    const mystery=selections.filter(s=>String(s.id)===String(vip.id));
    if(club ? !subscribe||count!==9||mystery.length!==1||mystery[0].quantity!==1 : mystery.length>0) throw Error('Pint of the Month needs eight chosen pints and one reserved mystery pint on subscription.');
    let planId = null;
    const items = [];
    for (const s of selections) {
      const product = await getProduct(s.handle);
      const variant = product.variants.find(v => String(v.id) === String(s.id));
      if (!variant?.available || variant.price !== 1490) throw Error('A selected flavor is unavailable or its box pricing is not ready. Your selections are saved.');
      let plan;
      if (subscribe) {
        const group = product.selling_plan_groups?.find(g => String(g.id) === (club ? vip.groupId : 'e881690fa1bcea0694f3b23c5025cb761ce5d286'));
        plan = group?.selling_plans.find(p => club ? p.id===vip.planId : p.name.toLowerCase() === `every ${frequency} weeks`);
        const allocation = variant.selling_plan_allocations?.find(a => a.selling_plan_id === plan?.id);
        if (!plan || allocation?.price !== 1341 || (planId && planId !== plan.id)) throw Error('A selected flavor is not configured for this subscription. Your selections are saved.');
        planId = plan.id;
      }
      items.push({id:variant.id, quantity:s.quantity, properties:{'_browndog_box':'individual-v2','_box_id':boxId,'Box size':`${count} pints`,...(club ? {'Club':'Pint of the Month','_bdj_club':'pint-of-the-month'} : {})}, ...(plan ? {selling_plan:plan.id} : {})});
    }
    return {items, planId, expected:target(count, subscribe)};
  }
  globalThis.BrowndogBoxCart = {target, isBox, restore, verify, prepare, vip};
})();
